import React from 'react';

import Status from './Status';

const StatusModal = props => {
  return (
    <div class={`status-modal-container ${props.modalFade}`}>
      <div class='container' >
        <div class='col-lg-6 col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2 col-xs-12 status-modal'>
          <button class='fa fa-close pull-right visible-xs' onClick={props.hideStatusModalWithAnimation} ></button>
          <Status {...props}/>
        </div>
      </div>
      <div class='status-modal-background' onClick={props.hideStatusModalWithAnimation} />
    </div>
  );
}

export default StatusModal;
